import { Platform } from "react-native";
import { Browser } from "sentry-expo";

export const replay =
  Platform.OS === "web"
    ? new Browser.Replay({
        maskAllText: false,

        networkDetailAllowUrls: ["https://api.storesprint.app/graphql"],
      })
    : undefined;
